/* eslint-disable react/jsx-max-depth */
import React, { useContext, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mantine/core';
import ResetPasswordForm from '../../components/forms/ResetPassword';
import LogoMap from '../../components/icons/logo';
import { ToastrContext } from '../../contexts';
import { RECAPTCHA_KEY } from '../../../env';
import { resetPasswordUser } from './actions';
import styles from './styles.scoped.css';

export default function ResetPassword() {
  const dispatch = useDispatch();
  const { isLoading, message, code } = useSelector(
    (state) => state.resetPassword
  );
  const { setToastr } = useContext(ToastrContext);

  useEffect(() => {
    if (!isLoading && message) {
      setToastr({
        visible: true,
        desc: message,
        type: code === 200 ? 'success' : 'danger',
      });
    }
  }, [isLoading, message]);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{ async: true }}
      useEnterprise={true}
    >
      <div className={styles.root}>
        <div>
          <Card className={styles.card}>
            <div className={styles.icDiv}>
              <LogoMap className={styles['logo-myptm']} />
            </div>
            <h3>Buat Kata Sandi Baru</h3>
            <p>Silakan masukkan kata sandi baru Anda</p>
            <ResetPasswordForm
              onSubmit={(value) => dispatch(resetPasswordUser(value))}
            />
          </Card>
        </div>
        <div>
          <img
            alt="illustration authenticator"
            src="/assets/illu-authenticator.svg"
          />
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
}
